import api from '../utils/api';

export interface AIPageDesign {
  _id: string;
  creationDate: string;
  fileLink?: string;
  type?: string[];
  aiPrompt?: string;
  note?: string;
  status: 'pending' | 'generated' | 'deployed' | 'archived';
  generatedCode?: string;
  aiModel?: string;
  lastModified: string;
}

export interface GenerateRequest {
  model?: 'gpt-4' | 'gpt-4-turbo' | 'gpt-3.5-turbo';
}

export interface GenerateResponse {
  design: AIPageDesign;
  result: {
    code: string;
    explanation: string;
    suggestions: string[];
  };
  validation: {
    isValid: boolean;
    errors: string[];
  };
}

export interface SaveFileRequest {
  fileName: string;
}

// Get all AI page designs
export const getAllDesigns = async (): Promise<AIPageDesign[]> => {
  const response = await api.get('/api/ai-page-designs');
  return response.data;
};

// Get single AI page design
export const getDesignById = async (id: string): Promise<AIPageDesign> => {
  const response = await api.get(`/api/ai-page-designs/${id}`);
  return response.data;
};

// Create new AI page design
export const createDesign = async (data: Partial<AIPageDesign>): Promise<AIPageDesign> => {
  const response = await api.post('/api/ai-page-designs', data);
  return response.data;
};

// Update AI page design
export const updateDesign = async (id: string, data: Partial<AIPageDesign>): Promise<AIPageDesign> => {
  const response = await api.put(`/api/ai-page-designs/${id}`, data);
  return response.data;
};

// Delete AI page design
export const deleteDesign = async (id: string): Promise<void> => {
  await api.delete(`/api/ai-page-designs/${id}`);
};

// Generate code using AI
export const generatePageCode = async (id: string, request: GenerateRequest = {}): Promise<GenerateResponse> => {
  const response = await api.post(`/api/ai-page-designs/${id}/generate`, request);
  return response.data;
};

// Save generated code to file
export const saveToFile = async (id: string, request: SaveFileRequest): Promise<{ 
  message: string; 
  filePath: string; 
  route: string;
  code?: string;
  design: AIPageDesign;
  note?: string;
}> => {
  const response = await api.post(`/api/ai-page-designs/${id}/save-file`, request);
  return response.data;
};
